import { render, staticRenderFns } from "./Creditoventa.vue?vue&type=template&id=23b45820&"
import script from "./Creditoventa.vue?vue&type=script&lang=js&"
export * from "./Creditoventa.vue?vue&type=script&lang=js&"
import style0 from "./Creditoventa.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports